module.exports = __webpack_public_path__ + "img/maintenance-en.457a74d.png";